module.exports = __webpack_public_path__ + "static/media/71wuT1b72QL._SL1500_.454c492a.jpg";